'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _sortInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/sort');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _endsWithInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/ends-with');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _sortInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sortInstanceProperty);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _endsWithInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_endsWithInstanceProperty);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);

var QueryMetaLogic = /*#__PURE__*/function () {
  function QueryMetaLogic() {
    _classCallCheck__default["default"](this, QueryMetaLogic);
  }
  return _createClass__default["default"](QueryMetaLogic, null, [{
    key: "loadFromGSQL",
    value: function loadFromGSQL(graphName, gsqlQueryMeta) {
      var _context,
        _context2,
        _this = this;
      // Init the query meta object
      var queryMeta = {
        queryName: gsqlQueryMeta.name,
        installed: gsqlQueryMeta.installed,
        enabled: gsqlQueryMeta.enabled,
        callerQueries: gsqlQueryMeta.callerQueries,
        installing: gsqlQueryMeta.installing,
        params: [],
        originalCode: gsqlQueryMeta.code,
        draftCode: gsqlQueryMeta.draft,
        graphUpdate: gsqlQueryMeta.graphUpdate,
        isHidden: gsqlQueryMeta.isHidden,
        isACLSpecified: gsqlQueryMeta.isACLSpecified,
        syntax: gsqlQueryMeta.syntax || 'GSQL'
      };

      // get the parameters
      var parameters = gsqlQueryMeta.endpoint.query ? gsqlQueryMeta.endpoint.query[graphName][gsqlQueryMeta.name]['GET/POST'].parameters : {};
      var orderedParams = _sortInstanceProperty__default["default"](_context = _filterInstanceProperty__default["default"](_context2 = _Object$keys__default["default"](parameters)
      // query itself is ignored, vertex type is ignored
      ).call(_context2, function (paramName) {
        return paramName !== 'query' && !_endsWithInstanceProperty__default["default"](paramName).call(paramName, '.type');
      })).call(_context, function (p1, p2) {
        return parameters[p1].index - parameters[p2].index;
      });
      _forEachInstanceProperty__default["default"](orderedParams).call(orderedParams, function (paramName) {
        // const param type based on param meta
        var paramMeta = parameters[paramName];
        var queryParamType = {
          type: paramMeta.type
        };
        // fix INT64 and UINT64
        if (queryParamType.type === 'INT64') {
          queryParamType.type = 'INT';
        }
        if (queryParamType.type === 'UINT64') {
          queryParamType.type = 'UINT';
        }
        // handle VERTEX type attribute
        if (paramMeta.is_id !== undefined) {
          queryParamType.type = 'VERTEX';
          // if paramName.type exists in parameters, means the vertex is any type vertex
          if (paramName + '.type' in parameters) {
            queryParamType.vertexType = '*';
          } else {
            // otherwise the vertex type is given in id_type
            queryParamType.vertexType = paramMeta.id_type;
          }
        }

        // Push the param meta into the query meta.
        // If max_count exists in the param meta, it is a list param, otherwise it is normal param
        var paramType = paramMeta.max_count ? {
          type: 'LIST',
          elementType: queryParamType
        } : queryParamType;

        // If the parameter has default value, set default value.
        if (parameters[paramName].defaultValue) {
          var defaultValue = parameters[paramName].defaultValue;
          queryMeta.params.push({
            paramName: paramName,
            paramType: paramType,
            paramDefaultValue: _this.handleParamDefaultValue(paramType, defaultValue)
          });
        } else {
          queryMeta.params.push({
            paramName: paramName,
            paramType: paramType
          });
        }
      });
      return queryMeta;
    }
  }, {
    key: "handleParamDefaultValue",
    value: function handleParamDefaultValue(paramType, paramDefaultValue) {
      return paramType.type === 'STRING' ? this.unescapeStr(paramDefaultValue) : paramDefaultValue;
    }
  }, {
    key: "unescapeStr",
    value: function unescapeStr(str) {
      return str.replace(/\\(.)/g, function (match, _char) {
        if (_char == '\\') return '\\';
        if (_char == 'n') return '\n';
        if (_char == 't') return '\t';
        if (_char == '') return '';
        return _char;
      });
    }
  }]);
}();

exports.QueryMetaLogic = QueryMetaLogic;
